export default "__VITE_ASSET__DaA4ppzB__"